import { InputHTMLAttributes } from 'react';

export const InputDays = ({
  disabled,
  label,
  value = '',
  onChange,
  placeholder,
}: InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  placeholder: string;
}) => {
  return (
    <div className="relative text-base">
      <label className="absolute -top-2 left-4 z-20 bg-white px-1 text-xs font-medium text-gray-200">
        {label}
      </label>
      <input
        type="number"
        min="0"
        max="100"
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="transition-color peer relative z-10 flex h-[50px] w-full rounded-md border border-gray-200 bg-transparent px-5 py-3.5 text-base [appearance:textfield] placeholder:text-base placeholder:text-gray-200 focus-visible:outline-none disabled:cursor-not-allowed md:px-3.5 md:py-2 md:text-sm [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      />
    </div>
  );
};
